import { useNavigate } from "react-router-dom";
import { Button } from "reactstrap";
import styles from './Unauthorized.module.scss';

const Unauthorized = () => {
    const navigate = useNavigate();

    const goBack = () => {
        navigate(-1);
    }

    return(
        <div className={`d-flex align-items-center justify-content-center flex-column ${styles.pageContainer}`}>
            <div className={`p-4`}>
                <div className={`fw-bolder ${styles.bigText}`}>
                    <i className="bi bi-person-slash"></i>
                </div>
                <h1>Unauthorized</h1>
                <p>
                    You do not have access to the requested page.
                </p>
                <Button onClick={goBack}>
                    Go Back
                </Button>
            </div>
        </div>
    )
}

export default Unauthorized;